export enum QuestionType {
    RadioButton = 'radiobutton',
    CheckBox = 'checkbox',
    TextBox = 'textbox',
}
